import { render } from "./IntentionCard.vue?vue&type=template&id=25df133e&scoped=true"
import script from "./IntentionCard.vue?vue&type=script&lang=js"
export * from "./IntentionCard.vue?vue&type=script&lang=js"

import "./IntentionCard.vue?vue&type=style&index=0&id=25df133e&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25df133e"]])

export default __exports__